// PARAQTA — light/dark тема ауыстыру.
// localStorage кілті: 'theme' — өзгеріссіз қалады.
// Авто dark mode (20:00–07:00) — index.html ішінде ерте IIFE жасайды.

export function toggleTheme() {
  const d = document.documentElement;
  const n = d.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
  d.setAttribute('data-theme', n);
  localStorage.setItem('theme', n);
  const icon = n === 'dark' ? '\u2600\uFE0F' : '\uD83C\uDF19';
  document.querySelectorAll('.btn-theme, #themeFloat')
    .forEach(el => { el.textContent = icon; });
}
